/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/arrow-up
 */
import { default as DefaultIcon } from '~icons/lucide/arrow-up';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const ArrowUpIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
